"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useFormValue;

var _react = require("react");

var _Editor = require("./Editor");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useFormValue(name) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useEditor = (0, _Editor.useEditor)(parent),
      subscribe = _useEditor.subscribe,
      getState = _useEditor.getState;

  var _useState = (0, _react.useState)(function () {
    return typeof name === 'function' ? name(getState()) : getState()[name];
  }),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  (0, _react.useEffect)(function () {
    return subscribe(name, setValue); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name]);
  return value;
}